@let texts = resourcesService.languageFile.value();
@let q = question();
@let qs = questionState();

<div class="question">
  <button class="select-answer-button no-default-styles"
          [attr.aria-label]="texts.expandOrCollapseAnswer + q.question"
          [attr.aria-expanded]="isExpanded"
          (click)="toggle()">
    <div class="question-summary">
      <div class="question-text">{{ q.question }}</div>
      <div class="spacer"></div>
      @if (qs) {
        <div class="desktop-attempts-indicator desktop-only">
          <ng-container *ngTemplateOutlet="attemptsIndicator; context: {qs}"/>
        </div>
      }
      @if (!isExpanded) {
        <i class="pi pi-chevron-right"></i>
      }
      @if (isExpanded) {
        <i class="pi pi-chevron-down"></i>
      }
    </div>
    @if (qs) {
      <div class="mobile-attempts-indicator mobile-only">
        <ng-container *ngTemplateOutlet="attemptsIndicator; context: {qs}"/>
      </div>
    }
  </button>
  @if (isExpanded && mapConfig()) {
    <div class="question-details">
      <div class="small-map">
        <gm-map id="small-map"
                [attr.json]="mapConfig()"
                options='{ "onlyAddVisibleLayers": true }'
                shared
                map_z="1"
        ></gm-map>
      </div>
      <div class="answer-description-and-link">
        @for (paragraph of q.answerDescription; track paragraph) {
          <div>{{ paragraph }}</div>
        }
        <div>
          <a [href]="q.answerLinkUrl" target="_blank">{{ texts.showOnMap }}</a>
        </div>
      </div>
    </div>
  }
</div>

<ng-template #attemptsIndicator let-qs="qs">
  <div class="attempts-indicator">
    @for (_ of Array(qs.attempt); track $index; let isLast = $last) {
      <div class="attempt"
           [class.correct]="isLast && qs.feedback === 'correct'"
      ></div>
    }
  </div>
</ng-template>
